/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".panel-message[_ngcontent-%COMP%]{padding:20px 40px;border:1px solid #c4c6c8;border-radius:5px;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);box-shadow:0 0 10px 0 #c4c6c8;z-index:10;background-color:#fff}@media (max-width:599px){.panel-message[_ngcontent-%COMP%]{width:90%}}"];
export { styles as styles };
